import { useParams } from 'react-router-dom';
import { useContainer, useHttpClient } from '../../hooks';
import { useUserContext } from '../../_runtime/iam/session.context';
import {
  buildPathFromObject,
  buildApiPathFromParams,
} from '@dirootie-core/api-types';
import { useMemo } from 'react';

// export const useApi = () => {
//   const httpClient = useHttpClient();
//   const urlParams = useParams();
//   const userContext = useUserContext();
//   const currentContextParams = {
//     ...urlParams,
//     ...userContext,
//   };

// };

export const useApiUrl = (
  template: string,
  params: Record<string, string> = {}
) => {
  const urlParams = useParams();
  const userContext = useUserContext();
  const currentContextParams = {
    ...params,
    ...urlParams,
    ...userContext,
  };
  const result = buildApiPathFromParams(template, currentContextParams as any);
  return result;
};

export const useApiUrlBuilder = () => {
  const userContext = useUserContext();
  return useMemo(
    () =>
      (template: string, params: Record<string, string> = {}) => {
        // this piece of code was adding the user's information to the query being sent
        // const currentContextParams = {
        //   ...userContext,
        // };
        const result = buildApiPathFromParams(
          template,
          {
            ...params,
            // ...currentContextParams,
          } as any,
          true
        );
        return result;
      },
    [userContext]
  );
};
